// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__Nt2we","total":"Cart_total__2z-jA","actions":"Cart_actions__3Wr0M","button":"Cart_button__3qBzD"};